<script setup>
import { Inertia } from '@inertiajs/inertia';
import { defineProps, reactive, watch, ref} from 'vue';
import { useForm } from "@inertiajs/inertia-vue3";
import Tiptap from '@/Shared/Editors/Tiptap.vue'
import ArrowLeftIcon from "@/Shared/SVG/ArrowLeftIcon";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

let props = defineProps({
    errors: Object,
    categories: Object,
    positionTypes: Object,
    countries: Object,
});

let form = useForm({
    position_category_id: null,
    title: null,
    type: null,
    country: null,
    brief_description: null,
    job_description: null,
    is_remote: true,
    is_active: true,
})

function submit() {
    Inertia.post('/backoffice/positions', form)
}
</script>

<template>
    <div class="max-w-7xl mx-auto px-4 flex justify-between items-center">
        <h1 class="text-2xl font-semibold text-gray-900">Positions</h1>
        <Link href="/backoffice/positions" class="text-sm text-wgn-blue-4 flex items-baseline"><ArrowLeftIcon class="mr-1 w-3 h-3"></ArrowLeftIcon>Back To Positions</Link>
    </div>
    <hr class="my-3">
    <div class="max-w-7xl mx-auto px-4 text-sm">
        <form @submit.prevent="submit">
            <div class="mt-2">
                <label for="position_category_id" class="font-bold">Category</label>
                <vSelect id="position_category_id" v-model="form.position_category_id" class="bg-white col-span-2" :options="categories" label="name" :reduce="name => name.id"></vSelect>
                <div v-if="errors.position_category_id" class="font-bold text-red-600">
                    {{ errors.position_category_id }}
                </div>
            </div>
            <div class="mt-2">
                <label for="title" class="font-bold">Title</label>
                <input type="text" v-model="form.title" class="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600"/>
                <div v-if="errors.title" class="font-bold text-red-600">
                    {{ errors.title }}
                </div>
            </div>
            <div class="mt-2">
                <label for="type" class="font-bold">Type</label>
                <vSelect id="type" v-model="form.type" class="bg-white col-span-2" :options="positionTypes" label="label" :reduce="label => label.value"></vSelect>
                <div v-if="errors.type" class="font-bold text-red-600">
                    {{ errors.type }}
                </div>
            </div>
            <div class="mt-2">
                <label for="country" class="font-bold">Country</label>
                <vSelect id="country" v-model="form.country" class="bg-white col-span-2" :options="countries" label="label" :reduce="label => label.value"></vSelect>
                <div v-if="errors.type" class="font-bold text-red-600">
                    {{ errors.country }}
                </div>
            </div>
            <div class="mt-2">
                <label for="brief_description" class="font-bold">Brief</label>
                <textarea
                    name="brief_description"
                    type="text"
                    v-model="form.brief_description"
                    class="w-full px-4 py-2 mt-1 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-600">
                </textarea>
                <div v-if="errors.brief_description" class="font-bold text-red-600">
                    {{ errors.brief_description }}
                </div>
            </div>
            <div class="mt-2">
                <label for="job_description" class="font-bold">Job Description</label>
                <tiptap v-model="form.job_description" :allowTable="false"/>
                <div v-if="errors.job_description" class="font-bold text-red-600">
                    {{ errors.job_description }}
                </div>
            </div>
            <div class="mt-2">
                <label for="is_remote" class="font-bold">Remote</label>
                <input
                    type="checkbox"
                    name="is_remote"
                    v-model="form.is_remote"
                    class="mx-2 border rounded-md border-gray-500"
                />
                <div v-if="errors.is_remote" class="font-bold text-red-600">
                    {{ errors.is_remote }}
                </div>
            </div>
            <div class="mt-2">
                <label for="is_active" class="font-bold">Active</label>
                <input
                    type="checkbox"
                    name="is_active"
                    v-model="form.is_active"
                    class="mx-2 border rounded-md border-gray-500"
                />
                <div v-if="errors.is_active" class="font-bold text-red-600">
                    {{ errors.is_active }}
                </div>
            </div>
            <div class="flex items-center mt-4">
                <button class="px-6 py-2 text-white bg-gray-900 rounded">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
import BackofficeLayout from '@/Layouts/BackofficeLayout'
export default {
    layout: BackofficeLayout,
}
</script>
